export const featureFlags = {
  development: {
    cart: true,
    methodPayments: true,
    ticketingBalance: true,
  },
  stage: {
    cart: true,
    methodPayments: true,
    ticketingBalance: false,
  },
  production: {
    cart: true,
    methodPayments: false,
    ticketingBalance: false,
  },
}
